import { provideMatDialogConfig } from "./mat-dialog.config";
import { provideMatFormFieldConfig } from "./mat-form-field.config";

export const provideMaterialConfigs = () => {
  return [provideMatFormFieldConfig(), provideMatDialogConfig()];
};
